<template>
  <div class="wrapper" data-app>
    <div
      class="participant-info list-user"
      :style="{
        filter:
          objectData?.is_cancel !== 1 && objectData?.can_payment !== 1
            ? 'blur(0.8px)'
            : ''
      }"
    >
      <div
        style="display: flex; align-items: center; padding:5px 0; min-height:45px"
      >
        <CheckBoxService style="flex-shrink: 0;" :item="objectData" />
        <div style="margin-left: 10px">
          <span class="participant-name">{{ objectData?.name }}</span>
        </div>
      </div>
      <div style="text-align: right; flex-shrink: 0;">
        <span class="participant-price" style="margin-left: auto"
          >{{ formatNumber(objectData?.amount) }} đ</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "@/plugins/init";

import iconPack from "@/assets/img/svg/pack.svg";
import { decodeToken } from "@/utils/auth";
import { getBackGround } from "@/utils/wapAuth";
import CheckBoxService from "@/views/pages/wapV2/history/components/CheckBoxService.vue";
export default {
  components: {
    CheckBoxService
  }, //, Comment
  bodyClass: "data-booking-services",
  props: {
    objectData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bg: getBackGround(),
      checked: false,
      large: "large",
      isShow: [],
      icons: {
        iconPack
      },
      form: {}
    };
  },
  created() {},

  watch: {},

  methods: {
    decodeToken,
    formatNumber
  },
  computed: {},
  mounted() {},

  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.checkbox {
  margin-left: 2px;
}

.quantity,
.status {
  display: block;
  font-size: 14px;
  font-weight: 400;
}

.price {
  font-size: 14px;
  color: #fb7800;
  display: block;
}

.participant-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  padding: 3px 10px;
  margin-bottom: 5px;
}

.participant-info.disabled {
  opacity: 0.5; /* Điều chỉnh độ mờ tùy ý */
}
.avatar {
  margin-left: 10px;
  width: 43px;
}

.participant-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.participant-name {
  line-height: 1.2;

  display: block;
  font-size: 15px;
  color: #000;
  font-weight: 400;
}
.participant-vid {
  display: block;
  font-size: 12px;
  color: #000;
  font-weight: 400;
}

.participant-price {
  display: block;
  font-size: 14px;
  color: #000;
  font-weight: 400;
}

.divider {
  //position: absolute;
  left: 0;
  right: 0;
  margin: 10px 0;
}

.content {
  margin-right: 12px;
  margin-left: 12px;
}

.value1 {
  font-size: 16px;
  font-weight: 600;
  color: #fb7800;
}
.value2 {
  font-size: 14px;
  font-weight: 400;
  color: #0095da;
}
.el-checkbox__inner {
  border-radius: 50% !important;
}

.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .header-top {
    padding-top: 60px !important;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>

<style lang="scss">
@media screen and (min-width: 0px) and (max-width: 769px) {
}

.mt-0 {
  margin-top: 0 !important;
}

.pointer {
  cursor: pointer;
}

.border-1 {
  border: 1px solid #ababab;
  border-radius: 10px;
}

.icon-image {
  height: 30px !important;
}

.text-not-break {
  word-break: keep-all !important;
}
</style>
